export function windowsColorRefToCssHexArgb(value: number): string {
  const n = Number(value);
  const r = n & 0xff;
  const g = (n >> 8) & 0xff;
  const b = (n >> 16) & 0xff;
  return '#' + [r, g, b].map(x => x.toString(16).padStart(2, '0')).join('');
}

/** Accepte "#RGB", "#RRGGBB", "RRGGBB" sans # */
export function cssHexToWindowsColorRefArgb(hexInput: string): number {
  const hex = hexInput.trim().replace(/^#/, '');
  const full =
    hex.length === 3
      ? hex
          .split('')
          .map(c => c + c)
          .join('')
      : hex;
  if (!/^[a-f\d]{6}$/i.test(full)) {
    return 0;
  }
  const n = parseInt(full, 16);
  const r = (n >> 16) & 0xff;
  const g = (n >> 8) & 0xff;
  const b = n & 0xff;
  return r | (g << 8) | (b << 16);
}

export function uniteColorFieldToColorBoxValue(v: unknown): string {
  if (v === undefined || v === null) {
    return '';
  }
  if (typeof v === 'number') {
    if (v === 0) {
      return '';
    }
    return windowsColorRefToCssHexArgb(v);
  }
  const s = String(v);
  if (s.startsWith('#')) {
    return s.toUpperCase();
  }
  if (/^-?\d+$/.test(s.trim())) {
    const n = parseInt(s.trim(), 10);
    if (Number.isNaN(n) || n === 0) {
      return '';
    }
    return windowsColorRefToCssHexArgb(n);
  }
  return s;
}
